// src/utils/storeAccessor.js
let store;

export const setStore = (_store) => {
  store = _store;
};

export const getStore = () => store;
